import type { Draft, WeekPlan } from '@content-planner/shared';

const PLATFORM_LABEL: Record<string, string> = {
  linkedin: 'LinkedIn',
  instagram: 'Instagram',
  facebook: 'Facebook',
};

const DAY_LABEL: Record<string, string> = {
  monday: 'Monday',
  wednesday: 'Wednesday',
  friday: 'Friday',
};

/**
 * Render the typed plan as plain, copy-pasteable text for the "copy plan"
 * button. Includes any drafted captions inline under their idea.
 */
export function weeksToText(
  weeks: WeekPlan[],
  month: string,
  drafts: Record<string, Draft> = {},
): string {
  const out: string[] = [];
  for (const week of weeks) {
    const range = week.dateRange ? ` · ${week.dateRange}` : '';
    out.push(`# Week ${week.week} — ${month}${range}`, '');
    for (const idea of week.ideas) {
      const platform = PLATFORM_LABEL[idea.platform] ?? idea.platform;
      out.push(`## ${DAY_LABEL[idea.day] ?? idea.day} · ${idea.pillar} · ${platform}`, '');
      out.push(idea.hook, '', idea.angle, '');
      if (idea.visual) out.push(`Visual idea: ${idea.visual}`, '');
      const draft = idea.id ? drafts[idea.id] : undefined;
      if (draft) out.push(`Draft (${platform}):`, draft.caption, '');
    }
  }
  return out.join('\n').trim();
}
